import HeadingText from "./headingText";
import SubHeading from "./subHeading";
import ErrorText from "./errorText";

export default {
    Heading: HeadingText,
    SubHeading,
    ErrorText
};